
import eServiceDataService from '@/services/eServiceDataService'
import moment from 'moment'
//import axios from "axios";

export default {
    name: 'News',
    data() {
        return {
            username: '',
            selected: '',
            news: '',
            data: [],
            columns: [],
            b_home: '',
            filter: '',
        }
    },
    methods: {
        async loadFileList(){

            await eServiceDataService.getNewsList().then(res => {
                console.log(res)
                var records = res.data.recordset;
                records.map(obj => {
                    obj.filepath = obj.filepath.replace('./upload', './doc/upload')
                    if(this.selected == 'en'){
                        if(obj.displayname_en !== null && obj.displayname_en !== 'undefined' && obj.displayname_en !== ''){
                            obj.filename = obj.displayname_en
                            obj.uploadDate = moment(obj.upload_date).format('YYYY-MM-DD')
                        }
                    }else{
                        if(obj.displayname_zh !== null && obj.displayname_zh !== 'undefined' && obj.displayname_zh !== ''){
                            obj.filename = obj.displayname_zh
                            obj.uploadDate = moment(obj.upload_date).format('YYYY-MM-DD')
                        }
                    }
                })

                this.data = records
            })
        },
        loadTableHeader(){
            if (this.username == 'haecostaff') {
                if(this.selected == 'en'){
                    this.columns = [
                        {
                            name: 'filename',
                            label: 'File Name',
                            field: row => row.filename,
                            format: val => `${val}`,
                            align: 'center',
                            sortable: true,
                            headerClasses: 'bg-primary text-white'
                        },
                        {
                            name: 'lastUploadDate',
                            label: 'Last Upload Date',
                            field: row => row.uploadDate,
                            format: val => `${val}`,
                            align: 'center',
                            sortable: true,
                            headerClasses: 'bg-primary text-white'
                        }
                    ]
                }else{
                    this.columns = [
                        {
                            name: 'filename',
                            label: '檔案',
                            field: row => row.filename,
                            format: val => `${val}`,
                            align: 'center',
                            sortable: true,
                            headerClasses: 'bg-primary text-white'
                        },
                        {
                            name: 'lastUploadDate',
                            label: '最後上傳日期',
                            field: row => row.uploadDate,
                            format: val => `${val}`,
                            align: 'center',
                            sortable: true,
                            headerClasses: 'bg-primary text-white'
                        }
                    ]
                }
            } else {
                if(this.selected == 'en'){
                    this.columns = [{
                            name: 'filename',
                            label: 'File Name',
                            field: row => row.filename,
                            format: val => `${val}`,
                            align: 'center',
                            sortable: true,
                            headerClasses: 'bg-primary text-white'
                        }
                    ]
                }else{
                    this.columns = [{
                            name: 'filename',
                            label: '檔案',
                            field: row => row.filename,
                            format: val => `${val}`,
                            align: 'center',
                            sortable: true,
                            headerClasses: 'bg-primary text-white'
                        }
                    ]
                }
            }        
        },
        readDoc(event, row){
            //this.$router.push({ name: 'NewsPDF', params: { pdf: row.filepath } })
            window.open(row.filepath, '_blank')
        }
    },
    mounted: async function () {
        this.selected = (localStorage.lang != null && localStorage.lang != '' && localStorage.lang != 'undefined' ? localStorage.lang : 'en');
        this.news = (localStorage.lang == 'en' ? 'News' : '最新消息');
        this.b_home = (localStorage.lang == 'en' ? 'Home' : '主頁');

        this.username = localStorage.getItem("username")
        //console.log(this.username)

        this.loadTableHeader();
        await this.loadFileList();
    }
}
